import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin, Clock, Phone, ChevronLeft, ChevronRight, Instagram } from 'lucide-react';

const locations = [
  {
    id: 1,
    name: 'Instituto Dr. José Walter',
    address: 'Rua Cel Procópio, 255, Cristiano Ozório - Poços de Caldas/MG',
    streetViewUrl: 'https://www.google.com/maps/embed?pb=!4v1709668800000!6m8!1m7!1s8XXLfEg8d5Ve2jjQcM7SAw!2m2!1d-21.7827047!2d-46.5617689!3f281.86!4f7.97!5f0.7525749891599827',
    mapsLink: 'https://www.google.com/maps/@-21.7827047,-46.5617689,0a,83.4y,281.86h,97.97t/data=!3m4!1e1!3m2!1s8XXLfEg8d5Ve2jjQcM7SAw!2e0?source=apiv3',
    hours: 'Segunda a Quinta: 9h às 19h\nSexta: 9h às 17h',
    phone: '(35) 98419-2693',
    whatsapp: '5535984192693',
    email: 'thiagoferreiranutri@gmail.com',
    instagram: '@instituto.drjosewalter',
    instagramUrl: 'https://www.instagram.com/instituto.drjosewalter?igsh=MWFrY2cyOTNzNDBpbA=='
  },
  {
    id: 2,
    name: 'La Vitalis',
    address: 'Av. Dr. David Benedito Otoni, 839, Jardim dos Estados - Poços de Caldas/MG',
    streetViewUrl: 'https://www.google.com/maps/embed?pb=!4v1709668900000!6m8!1m7!1sN5JZduYIceE9HTUQHOvvLA!2m2!1d-21.7795783!2d-46.5586892!3f226.21!4f-6.64!5f0.7525749891599827',
    mapsLink: 'https://www.google.com/maps/@-21.7795758,-46.5586871,0a,83.4y,226.21h,83.36t/data=!3m4!1e1!3m2!1sN5JZduYIceE9HTUQHOvvLA!2e0?source=apiv3',
    hours: 'Segunda a Quinta: 8h às 19h\nSexta: 8h às 17h',
    phone: '(35) 99848-7788',
    whatsapp: '5535998487788',
    email: 'thiagoferreiranutri@gmail.com',
    instagram: '@la.vitalis',
    instagramUrl: 'https://www.instagram.com/la.vitalis?igsh=aTBqYWYweDhrN28x'
  },
  {
    id: 3,
    name: 'Dra. Ellen Rocha',
    address: 'Rua Santos Dumont, 182, São Benedito - Poços de Caldas/MG',
    streetViewUrl: 'https://www.google.com/maps/embed?pb=!4v1709669000000!6m8!1m7!1sDauimuaRhRagiEm8PtjrEw!2m2!1d-21.7915862!2d-46.5616146!3f244.08!4f8.97!5f0.7525749891599827',
    mapsLink: 'https://www.google.com/maps/@-21.7915862,-46.5616146,0a,83.4y,244.08h,98.97t/data=!3m4!1e1!3m2!1sDauimuaRhRagiEm8PtjrEw!2e0?source=apiv3',
    hours: 'Segunda a Quinta: 8h às 19h\nSexta: 8h às 17h',
    phone: '(35) 3712-1656',
    whatsapp: '553537121656',
    email: 'thiagoferreiranutri@gmail.com',
    instagram: '@clinicadraellenrocha',
    instagramUrl: 'https://www.instagram.com/clinicadraellenrocha?igsh=Nm00bjhrdWF0aWxs'
  }
];

const Location = () => {
  const [currentLocation, setCurrentLocation] = useState(0);
  const location = locations[currentLocation];

  const nextLocation = () => {
    setCurrentLocation((prev) => (prev + 1) % locations.length);
  };

  const prevLocation = () => {
    setCurrentLocation((prev) => (prev - 1 + locations.length) % locations.length);
  };

  return (
    <section className="section-spacing bg-[#F2F0E9] relative overflow-hidden" id="localizacao">
      {/* Topographic-style lines */}
      <svg className="absolute inset-0 w-full h-full opacity-[0.03] pointer-events-none" preserveAspectRatio="none" viewBox="0 0 1200 800">
        <path d="M0 400 Q300 350 600 400 T1200 380" fill="none" stroke="#11830f" strokeWidth="1.5"/>
        <path d="M0 420 Q300 370 600 420 T1200 400" fill="none" stroke="#11830f" strokeWidth="1"/>
        <path d="M0 440 Q300 390 600 440 T1200 420" fill="none" stroke="#11830f" strokeWidth="0.8"/>
        <path d="M0 300 Q400 260 800 300 T1200 280" fill="none" stroke="#11830f" strokeWidth="1.2"/>
        <path d="M0 320 Q400 280 800 320 T1200 300" fill="none" stroke="#11830f" strokeWidth="0.8"/>
        <path d="M0 520 Q200 480 500 520 T1200 500" fill="none" stroke="#11830f" strokeWidth="1"/>
        <path d="M0 540 Q200 500 500 540 T1200 520" fill="none" stroke="#11830f" strokeWidth="0.6"/>
      </svg>
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl md:text-5xl font-semibold tracking-tight text-[#1A1A1A] mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Locais de <span className="text-brand-green">Atendimento</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-6">
            Atendemos em 3 clínicas em Poços de Caldas! Escolha a mais próxima de você.
          </p>

          {/* Seletor de Unidades */}
          <div className="flex items-center justify-center gap-4 mb-8">
            <button
              onClick={prevLocation}
              className="w-10 h-10 rounded-full bg-white shadow-md flex items-center justify-center hover:bg-brand-green hover:text-white transition-all"
              data-testid="prev-location"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>

            <div className="flex gap-2">
              {locations.map((loc, index) => (
                <button
                  key={loc.id}
                  onClick={() => setCurrentLocation(index)}
                  className={`px-6 py-3 rounded-full font-semibold transition-all ${
                    index === currentLocation
                      ? 'bg-brand-green text-white shadow-lg'
                      : 'bg-white text-gray-600 hover:bg-gray-50'
                  }`}
                  data-testid={`location-tab-${index}`}
                >
                  {loc.name}
                </button>
              ))}
            </div>

            <button
              onClick={nextLocation}
              className="w-10 h-10 rounded-full bg-white shadow-md flex items-center justify-center hover:bg-brand-green hover:text-white transition-all"
              data-testid="next-location"
            >
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>
        </motion.div>

        <AnimatePresence mode="wait">
          <motion.div
            key={currentLocation}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="grid grid-cols-1 lg:grid-cols-3 gap-8"
          >
            {/* Informações */}
            <div className="space-y-6">
              <div className="bg-white rounded-2xl p-6 shadow-md">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-full bg-brand-green flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#1A1A1A] mb-2">Endereço</h3>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      {location.address}
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-md">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-full bg-brand-green flex items-center justify-center flex-shrink-0">
                    <Clock className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#1A1A1A] mb-2">Horários</h3>
                    <p className="text-gray-600 text-sm leading-relaxed whitespace-pre-line">
                      {location.hours}
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-md">
                <div className="flex items-start gap-4">
                  <a href={`https://wa.me/${location.whatsapp}?text=${encodeURIComponent('Olá, gostaria de mais informações sobre a consulta do Thiago Ferreira nutricionista, por favor.')}`} target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-brand-green flex items-center justify-center flex-shrink-0 hover:bg-[#0d6a0c] transition-colors">
                    <Phone className="w-6 h-6 text-white" />
                  </a>
                  <div>
                    <h3 className="font-semibold text-[#1A1A1A] mb-2">Contato</h3>
                    <a href={`https://wa.me/${location.whatsapp}?text=${encodeURIComponent('Olá, gostaria de mais informações sobre a consulta do Thiago Ferreira nutricionista, por favor.')}`} target="_blank" rel="noopener noreferrer" className="text-gray-600 text-sm leading-relaxed hover:text-brand-green transition-colors block">
                      {location.phone}
                    </a>
                    <a href={location.instagramUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-brand-green font-semibold text-sm hover:underline transition-colors mt-1">
                      <Instagram className="w-4 h-4" style={{ color: '#E1306C' }} />
                      {location.instagram}
                    </a>
                  </div>
                </div>
              </div>

              <button
                onClick={() => window.open(location.mapsLink, '_blank')}
                className="w-full bg-brand-green text-white px-6 py-4 rounded-full font-semibold text-base shadow-lg hover:shadow-xl hover:bg-[#0d6a0c] transition-all"
                data-testid="open-maps-button"
              >
                Abrir no Google Maps
              </button>
            </div>

            {/* Street View */}
            <div className="lg:col-span-2">
              <div className="bg-white rounded-2xl overflow-hidden shadow-2xl h-full min-h-[500px]">
                <iframe
                  key={location.id}
                  src={location.streetViewUrl}
                  width="100%"
                  height="100%"
                  style={{ border: 0, minHeight: '500px' }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title={`Localização ${location.name}`}
                  data-testid="street-view-map"
                ></iframe>
              </div>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    </section>
  );
};

export default Location;
